import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
import {
	getToken,
	getInfo,
	getUniqueness,
	setToken,
	setUserInfo,
} from './common/utils/auth.js'
import {
	getAuthorUserInfo
} from './common/api/user.js'
import { resolve } from 'core-js/es6/promise'
import { reject } from 'core-js/fn/promise'
const CancelToken = axios.CancelToken

// export default new Vuex.Store({
const store = new Vuex.Store({
	//当前的状态
	state: {
		source: CancelToken.source(), // 存放axios的取消令牌
		pageTitle: '',
		isBack: false,
		userInfo: getInfo(),
		token: getToken(),
		uniqueness: '',
		googleId:"849421071823-7649e3vjt4595svhi5f9891a0l8h3l2e.apps.googleusercontent.com",
		facebookId:"1458322228024211"
	},
	//声明同步的方法
	mutations: {
		setGoogleId(state, googleId){
			state.googleId = googleId
		},
		setSource(state, obj) {
			// 路由切换是新建取消令牌，并写入store
			state.source = obj
		},
		setPageTitle(state, str) {
			state.pageTitle = str
		},
		setBackStatus(state, bo) {
			state.isBack = bo
		},
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_UserInfo: (state, userInfo) => {
			state.userInfo = userInfo
		},
		loginOut(state) {
			console.log('11')
			state.token = ''
			state.userInfo = {}
			state.roles = []
			sessionStorage.removeItem('vue_admin_template_UserInfo')
			sessionStorage.removeItem('vue_admin_template_token')
			sessionStorage.removeItem('vue_admin_template_token')
			console.log('22')
			// localStorage.removeItem('expires')
			// localStorage.removeItem('router')
		}
	},
	//声明异步的方法
	actions: {
		//登录拿到token
		login({
			commit
		}, provider) {
			return new Promise((resolve,reject) =>{
				const state = store.state
				const token = provider.token
				const expires = provider.expires
				commit('SET_TOKEN', token)
				setToken(token)
				const data = {
					data: {}
				}
				getAuthorUserInfo(data).then(res => {
					if(res.code == 0){
						commit('SET_UserInfo', res.data)
						let userInfo = JSON.stringify(res.data)
						setUserInfo(userInfo)
						try {
							$gwreader.branchEvent('LOGIN' + ',' + userInfo.id)
						} catch (e) {
							//TODO handle the exception
						}
						resolve();
					}
					// try {
					// 	$gwreader.branchEvent('LOGIN' + ',' + userInfo.id)
					// } catch (e) {
					// 	//TODO handle the exception
					// }
				}).catch(error => {
					let {
						err,
						res
					} = error;
					reject(err)
				})
			})
			
			
			
			// const state = store.state
			// const token = provider.token
			// const expires = provider.expires
			// commit('SET_TOKEN', token)
			// setToken(token)
			// const data = {
			// 	data: {}
			// }
			// getAuthorUserInfo(data).then(res => {
			// 	commit('SET_UserInfo', res.data)
			// 	console.log('getAuthorUserInfo11111111', res.data);
			// 	let userInfo = JSON.stringify(res.data)
			// 	setUserInfo(userInfo)
			// 	try {
			// 		$gwreader.branchEvent('LOGIN' + ',' + userInfo.id)
			// 	} catch (e) {
			// 		//TODO handle the exception
			// 	}
			// }).catch(error => {
			// 	let {
			// 		err,
			// 		res
			// 	} = error;
			// })
		}
	}
})
//导出store对象
export default store
